import { axios } from "configs/axios";

export type ResetPasswordDTO = {
  email: string;
};

export const resetPassword = (
  data: ResetPasswordDTO
) => {
  return axios.post("/auth/resetpassword", { email: data.email });
};